/* src/app/pages/statement/modal-wrapper/modal-wrapper.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
h1,
h2,
h3,
h4,
h5,
h6,
label,
p,
b,
small,
span,
strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
h1.cds-required::after,
h2.cds-required::after,
h3.cds-required::after,
h4.cds-required::after,
h5.cds-required::after,
h6.cds-required::after,
label.cds-required::after,
p.cds-required::after,
b.cds-required::after,
small.cds-required::after,
span.cds-required::after,
strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
h1[class^=c-],
h2[class^=c-],
h3[class^=c-],
h4[class^=c-],
h5[class^=c-],
h6[class^=c-],
label[class^=c-],
p[class^=c-],
b[class^=c-],
small[class^=c-],
span[class^=c-],
strong[class^=c-] {
  color: var(--color);
}
b,
strong,
span {
  font-family: var(--cds-font-family);
}
h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
p.bold {
  font-weight: bold;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host {
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-shadow:
    0px 6px 6px -3px hsla(var(--cds-shadow-600-hsl), 0.12),
    0px 10px 14px 1px hsla(var(--cds-shadow-600-hsl), 0.09),
    0px 4px 18px 3px hsla(var(--cds-shadow-600-hsl), 0.08);
  position: relative;
  padding: 0px 24px;
  background: var(--cds-background-main);
  border-radius: 8px;
  width: 989px;
}
:host ::ng-deep bfm-amount-header {
  display: none !important;
}
:host ::ng-deep bfm-amount-form .amount-card {
  padding: 16px !important;
  border-radius: 4px;
  border: 1px solid var(--cds-border);
  box-shadow: 0px 1px 2px 0px color-mix(in srgb, var(--cds-foreground-600) 30%, transparent), 0px 1px 3px 1px color-mix(in srgb, var(--cds-foreground-600) 15%, transparent);
}
:host ::ng-deep bfm-amount-form .main-info-container {
  grid-template: unset;
  grid-template-columns: repeat(3, 1fr) !important;
  grid-template-rows: auto !important;
  gap: 0px !important;
}
:host ::ng-deep bfm-amount-form .main-info-container fieldset {
  min-height: unset !important;
}
:host ::ng-deep bfm-amount-form .main-info-container fieldset h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 600;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-amount-form .main-info-container #client-description-field,
:host ::ng-deep bfm-amount-form .main-info-container #cost-center-field {
  margin-right: 15px;
}
:host ::ng-deep bfm-amount-form .main-info-container #amount-field {
  border-bottom: 2px solid var(--cds-background-accent);
  padding-bottom: 10px;
  margin-bottom: 24px;
}
:host ::ng-deep bfm-amount-form .main-info-container #amount-field h6 {
  font-weight: 400 !important;
}
:host ::ng-deep bfm-amount-form .main-info-container #amount-field .amount-form-value {
  font-weight: 700 !important;
  font-size: 16px !important;
  justify-content: center;
  min-height: 48px;
}
:host ::ng-deep bfm-amount-form .main-info-container #classification-field {
  grid-column: span 2 !important;
  border-bottom: 2px solid var(--cds-background-accent);
  padding-bottom: 10px;
  margin-bottom: 24px;
}
:host ::ng-deep bfm-amount-form .main-info-container #classification-field h6 {
  font-weight: 400 !important;
}
:host ::ng-deep bfm-amount-form .main-info-container #classification-field .amount-form-value {
  font-weight: 700 !important;
  font-size: 16px !important;
}
:host ::ng-deep bfm-amount-form .main-info-container #observation-field {
  grid-column: span 3 !important;
  margin-top: 24px !important;
}
:host ::ng-deep bfm-amount-form .main-info-container #observation-field textarea {
  height: 40px !important;
  min-height: 40px !important;
  padding: 12px !important;
}
:host ::ng-deep bfm-record-name-autocomplete button {
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep bfm-record-name-autocomplete button i {
  font-size: 20px !important;
}
:host ::ng-deep bfm-record-name-autocomplete input {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: 700;
  color: var(--cds-text-strong);
  line-height: 1;
  padding: 0 10px !important;
}
:host ::ng-deep bfm-record-name-autocomplete input[readonly]:focus-visible {
  border: none !important;
  outline: none !important;
  caret-color: transparent;
  cursor: default !important;
}
:host ::ng-deep bfm-financial-record-payment-info form {
  margin: 12px 0 0 !important;
}
:host ::ng-deep bfm-financial-record-payment-info form .form-row {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom: 2px solid var(--cds-background-accent);
  padding-bottom: 10px;
}
:host ::ng-deep bfm-financial-record-payment-info form .form-row label {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 600;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-financial-record-payment-info form .form-row .payment-info-value,
:host ::ng-deep bfm-financial-record-payment-info form .form-row small,
:host ::ng-deep bfm-financial-record-payment-info form .form-row h6 {
  color: var(--cds-text-strong) !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
}
:host ::ng-deep bfm-financial-record-details .record-name-row {
  gap: 2px !important;
}
:host ::ng-deep bfm-financial-record-details #main-info {
  border-bottom: 2px solid var(--cds-background-accent);
  padding-bottom: 10px;
}
:host ::ng-deep bfm-financial-record-details #status-icons {
  font-size: 24px !important;
}
:host ::ng-deep bfm-financial-record-details #status-icons .c-success {
  color: var(--cds-revenue) !important;
}
:host ::ng-deep bfm-financial-record-details #amounts {
  margin: 24px 0px 42px 0px !important;
}
:host ::ng-deep bfm-financial-record-details #history {
  margin: 42px 0px 24px 0px !important;
}
:host ::ng-deep bfm-financial-record-details #payment-info {
  margin: 24px 0px 0px 0px !important;
}
:host ::ng-deep bfm-financial-record-details #amounts-current-value small {
  display: block;
  margin-bottom: 10px;
  font-size: 16px !important;
  font-weight: 400 !important;
  color: var(--cds-text-strong) !important;
}
:host ::ng-deep bfm-financial-record-details #amounts-current-value h1 {
  font-size: 16px !important;
  font-weight: 700 !important;
}
:host ::ng-deep bfm-financial-record-details header {
  gap: 6px !important;
}
:host ::ng-deep bfm-financial-record-details header h2 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: 700;
  color: var(--cds-primary-500);
  line-height: 1;
}
:host ::ng-deep bfm-financial-record-details header p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-primary-500);
  line-height: 1;
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep bfm-financial-record-history {
  background: var(--cds-background-accent);
}
:host ::ng-deep .label-note {
  color: var(--cds-text-light);
  font-weight: 400;
  margin-left: 4px;
}
/*# sourceMappingURL=modal-wrapper.component.css.map */
